import React from "react";
import { Link } from "react-router-dom";
import { FaBookOpen, FaCheckCircle, FaRocket } from "react-icons/fa";

function SignPlan() {
  const premiumItems = [
    "Gestao completa de processos e prazos",
    "Financeiro, timesheet e relatorios",
    "IA e produtividade em uma unica plataforma",
  ];

  const ebookItems = [
    "Visao geral da plataforma",
    "Fluxo de uso para novos usuarios",
    "Material rapido para avaliacao comercial",
  ];

  return (
    <div className="container presentation-shell px-4 px-lg-5 position-relative z-1 py-5">
      <div className="section-intro text-center mx-auto mb-5">
        <span className="section-kicker">Conversao</span>
        <h2 className="section-title text-dark">Pronto para transformar sua advocacia?</h2>
        <p className="section-description section-description-muted">
          Mantive a CTA forte, mas agora com hierarquia visual mais clara,
          simetria melhor entre os cards e contraste suficiente para destacar as acoes.
        </p>
      </div>

      <div className="row g-4 justify-content-center">
        <div className="col-12 col-lg-6">
          <article className="plan-card plan-card-primary h-100">
            <div className="plan-card-icon">
              <FaRocket className="fs-2 text-dark" />
            </div>

            <span className="plan-card-label">Plano premium</span>
            <h3 className="plan-card-title text-dark">Assine agora</h3>
            <p className="plan-card-description text-dark">
              Tenha acesso imediato a todas as ferramentas premium para escalar
              a operacao do seu escritorio com mais controle.
            </p>

            <div className="plan-card-list">
              {premiumItems.map((item) => (
                <div key={item} className="plan-card-item text-dark">
                  <FaCheckCircle />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <Link
              to="/planos"
              className="btn btn-dark-premium-solid fw-bold rounded-pill mt-auto py-3 text-uppercase tracking-wide"
            >
              Ver planos
            </Link>
          </article>
        </div>

        <div className="col-12 col-lg-6">
          <article className="plan-card plan-card-secondary h-100">
            <div className="plan-card-icon plan-card-icon-muted">
              <FaBookOpen className="fs-2 text-gold" />
            </div>

            <span className="plan-card-label text-gold">Material gratuito</span>
            <h3 className="plan-card-title text-dark">E-book gratuito</h3>
            <p className="plan-card-description text-secondary">
              Entenda a proposta da plataforma e como ela organiza a rotina
              juridica antes de seguir para a contratacao.
            </p>

            <div className="plan-card-list">
              {ebookItems.map((item) => (
                <div key={item} className="plan-card-item text-secondary">
                  <FaCheckCircle className="text-gold" />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <a
              href="https://easyvog-pdfs.s3.sa-east-1.amazonaws.com/E-BOOK+EASYVOG.pdf"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-premium fw-bold rounded-pill mt-auto py-3 text-uppercase tracking-wide"
            >
              Baixar e-book
            </a>
          </article>
        </div>
      </div>
    </div>
  );
}

export default SignPlan;
